import { Paper, styled } from '@mui/material';
// TODO: check if it is still used.
export const BackdropPaper = styled(Paper)({
    display: 'flex',
    flex: 1,
    position: 'relative',
});
